// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Slider__filled-e6cda5 {
  height: 100%;
  background-color: var(--brand-primary-40);
  position: absolute;
  z-index: 1;
  border-radius: 4px;
  pointer-events: none;
}

.Slider__slider-f90b6d {
  -webkit-appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 0;
  margin: 0;
  left: 0;
  cursor: pointer;
  border-radius: 4px;
  background: var(--brand-primary-40);
}
.Slider__slider-f90b6d::-webkit-slider-runnable-track {
  height: 2px;
  background: var(--base-40);
  border: none;
  border-radius: 4px;
}
.Slider__slider-f90b6d::-moz-range-track {
  height: 2px;
  background: var(--base-40);
  border: none;
  border-radius: 4px;
}
.Slider__slider-f90b6d::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: none;
  height: 12px;
  width: 12px;
  border-radius: 100%;
  background: var(--brand-primary-40);
  margin-top: -5px;
  z-index: 2;
  position: relative;
}
.Slider__slider-f90b6d::-moz-range-thumb {
  -webkit-appearance: none;
  border: none;
  height: 12px;
  width: 12px;
  border-radius: 100%;
  background: var(--brand-primary-40);
  margin-top: -5px;
  z-index: 2;
  position: relative;
}
.Slider__slider-f90b6d:focus {
  outline: none !important;
}
.Slider__slider-f90b6d:active {
  outline: none !important;
}
.Slider__slider-f90b6d::-moz-focus-outer {
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/AudioPlayer/Slider/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AACF;;AACA;EACE,wBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,mCAAA;AAEF;AAAE;EACE,WAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;AAEJ;AACE;EACE,WAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAEE;EACE,wBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAAJ;AAGE;EACE,wBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AADJ;AAIE;EACE,wBAAA;AAFJ;AAKE;EACE,wBAAA;AAHJ;AAME;EACE,SAAA;AAJJ","sourcesContent":[".filled {\n  height: 100%;\n  background-color: var(--brand-primary-40);\n  position: absolute;\n  z-index: 1;\n  border-radius: 4px;\n  pointer-events: none;\n}\n.slider {\n  -webkit-appearance: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--brand-primary-40);\n\n  &::-webkit-slider-runnable-track {\n    height: 2px;\n    background: var(--base-40);\n    border: none;\n    border-radius: 4px;\n  }\n\n  &::-moz-range-track {\n    height: 2px;\n    background: var(--base-40);\n    border: none;\n    border-radius: 4px;\n  }\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    border: none;\n    height: 12px;\n    width: 12px;\n    border-radius: 100%;\n    background: var(--brand-primary-40);\n    margin-top: -5px;\n    z-index: 2;\n    position: relative;\n  }\n\n  &::-moz-range-thumb {\n    -webkit-appearance: none;\n    border: none;\n    height: 12px;\n    width: 12px;\n    border-radius: 100%;\n    background: var(--brand-primary-40);\n    margin-top: -5px;\n    z-index: 2;\n    position: relative;\n  }\n\n  &:focus {\n    outline: none !important;\n  }\n\n  &:active {\n    outline: none !important;\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filled": `Slider__filled-e6cda5`,
	"slider": `Slider__slider-f90b6d`
};
module.exports = ___CSS_LOADER_EXPORT___;
